'use client';

import { Children, cloneElement } from 'react';

import { usePopperContext } from './hooks';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement | ReactElement[];
}

export const PopperHoverLeave: FC<ToggleProps> = ({ children }) => {
  const { handleClose } = usePopperContext();

  return (
    <>
      {Children.map( children, (child) => cloneElement( child, { onMouseLeave: handleClose } ) )}
    </>
  );
};
